module.exports = __webpack_public_path__ + "img/1.b2ece716.png";